(function() {
  var BaseHandler, DetailOutput, LoadingHandler,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  BaseHandler = App.loadClass("core::reports/BaseHandler");

  DetailOutput = App.loadClass("core::reports/DetailOutput");

  LoadingHandler = App.loadClass("core::FullPageLoadingHandler");

  exports.Keyfields_SubHandler = (function(superClass) {
    extend(Keyfields_SubHandler, superClass);

    function Keyfields_SubHandler() {
      this.updateBoundaries = bind(this.updateBoundaries, this);
      this.createClusterIcon = bind(this.createClusterIcon, this);
      return Keyfields_SubHandler.__super__.constructor.apply(this, arguments);
    }

    Keyfields_SubHandler.prototype.init = function(modalInstance) {
      var opt, ref;
      this.modalInstance = modalInstance;
      this.layoutUrl = 'backend/portal/keyfields/load-layout';
      this.filterUrl = 'backend/portal/keyfields/filters';
      this.layoutSelector = '#keyfields_container';
      this.refreshNavHandler = false;
      this.parent.topBuffer = function() {
        return parseInt(App.sidebar.element.outerHeight()) - 55;
      };
      this.oldMaxZoom = App.map.options.maxZoom;
      App.map.options.maxZoom = 17;
      this.maxZoom = 12;
      this.group_len = 100;
      this.availableStatus = {
        "Not Key": "#dddddd",
        "Not Started": "#BE4948",
        "Incomplete": "#F89406",
        "Complete": "#3A894C"
      };
      this.icons = {};
      this.generateMarkerIcons();
      opt = {
        "status": {
          opt1: {
            key: "Incomplete",
            value: "Incomplete"
          },
          opt2: {
            key: "Not Started",
            value: "Not Started"
          },
          opt3: {
            key: "Complete",
            value: "Complete"
          }
        }
      };
      if ((ref = this.loader) != null) {
        ref.destroy();
      }
      this.loader = this.createSubHandler(LoadingHandler);
      if (this.loader) {
        this.loader.init("Loading Key Fields...");
      }
      return this.setDefaultsAndRun(0, 0, 0, opt);
    };


    /*
     *
     * Initialize marker icons. These are the pushpins that represent
     * an order on the map, and they are colorcoded by order stage.
     */

    Keyfields_SubHandler.prototype.generateMarkerIcons = function() {
      var color, ref, results, status;
      ref = this.availableStatus;
      results = [];
      for (status in ref) {
        color = ref[status];
        results.push(this.icons[status] = new L.mapbox.marker.icon({
          "marker-size": "large",
          "marker-color": color,
          "marker-symbol": "farm"
        }));
      }
      return results;
    };

    Keyfields_SubHandler.prototype.afterLoadLayout = function(sel, data) {
      var fid, id, ref, ref1, self;
      self = this;
      this.year = data.data.year;
      this.fieldlist = [];
      this.fieldsOnMap = [];
      this.keyFieldMarkers = {};
      ref = data.data.fields;
      for (id in ref) {
        fid = ref[id];
        this.fieldlist.push(id);
        this.fieldsOnMap.push(parseInt(id));
      }
      if (this._post != null) {
        this._post.abort();
      }
      if (this._timer != null) {
        clearTimeout(this._timer);
      }
      $("#map_canvas").undelegate();
      this.EventGetDirections();
      this.EventAddStandCount();
      this.EventAddErl();
      this.EventFindClosestKey();
      App.layer_store.empty();
      this.markerLayer = new L.MfMarkerClusterGroup({
        iconCreateFunction: this.createClusterIcon,
        zoomToBoundsOnClick: true
      });
      this.boundaryLayer = new L.FeatureGroup();
      App.layer_store.store("marker_cluster", this.markerLayer);
      App.layer_store.store("fields_layer", this.boundaryLayer);
      App.map.on('zoomend', this.updateBoundaries);
      if (data.data.fields.length > 0) {
        App.map.fitBounds([[data.data.bounds.south, data.data.bounds.west], [data.data.bounds.north, data.data.bounds.east]]);
      }
      this.fetchField();
      if (Array.isArray(this.year) && !this.year.length) {
        if ((ref1 = this.loader) != null) {
          ref1.destroy();
        }
        this.loader = this.createSubHandler(LoadingHandler);
        if (this.loader) {
          return this.loader.init('You must select at least one year in order to run this tool');
        }
      }
    };


    /*
    Event listener to get directions
     */

    Keyfields_SubHandler.prototype.EventGetDirections = function() {
      return $("#map_canvas").delegate('.get-directions-form', 'submit', function(e) {
        var form;
        e.preventDefault();
        form = $("#map_canvas").find('.get-directions-form').serialize();
        return window.open("http://maps.google.com/maps?" + form + "&hl=en");
      });
    };


    /*
    Event listener to add stand count record
     */

    Keyfields_SubHandler.prototype.EventAddStandCount = function() {
      var self;
      self = this;
      return $("#map_canvas").delegate('.add-sc', 'click', (function(_this) {
        return function(e) {
          var field_id;
          field_id = $(e.currentTarget).closest('div').siblings('[name="fields_id"]').val();
          return _this.modalInstance.openStandCountDialog(field_id, _this.year, 0).modalRef.result.then(function(response) {
            return _this.updatePopupAndMarker(e.currentTarget, field_id, '.add-sc');
          });
        };
      })(this));
    };


    /*
    Event listener to add ear, row, length record
     */

    Keyfields_SubHandler.prototype.EventAddErl = function() {
      var self;
      self = this;
      return $("#map_canvas").delegate('.add-erl', 'click', (function(_this) {
        return function(e) {
          var field_id;
          field_id = $(e.currentTarget).closest('div').siblings('[name="fields_id"]').val();
          return _this.modalInstance.openERLDialog(field_id, _this.year, 'Add').modalRef.result.then(function(response) {
            return _this.updatePopupAndMarker(e.currentTarget, field_id, '.add-erl');
          });
        };
      })(this));
    };


    /*
    Event listener to find closest point
     */

    Keyfields_SubHandler.prototype.EventFindClosestKey = function() {
      var self;
      self = this;
      return $("#map_canvas").delegate('.closest-point', 'click', function(e) {
        var field_id, postParams;
        $(e.currentTarget).attr('disabled', 'disabled');
        $(e.currentTarget).find('span').html('Searching for key field...');
        field_id = $(e.currentTarget).closest('div').siblings('[name="fields_id"]').val();
        postParams = {
          ids: ko.toJSON(field_id),
          years: ko.toJSON(self.year),
          getClosestKey: true
        };
        return $.post('backend/portal/keyfields/field-info', postParams, function(response) {
          var fid, field, obj, ref;
          if (response.data != null) {
            field = response.data[0].field;
            if ((self.fieldsOnMap.indexOf(field.id)) === -1) {
              self.addFields(response.data);
              self.fieldsOnMap.push(field.id);
            }
            ref = self.keyFieldMarkers;
            for (fid in ref) {
              obj = ref[fid];
              if ((parseInt(field.id)) === (parseInt(fid))) {
                setTimeout(function() {
                  return obj.marker.openPopup();
                }, 500);
                break;
              }
            }
            App.map.fitBounds([[field.south, field.west], [field.north, field.east]]);
            self.updateBoundaries();
            $(e.currentTarget).find('span').html('Closest Key Point');
            return $(e.currentTarget).removeAttr('disabled');
          } else {
            return $(e.currentTarget).find('span').html('No key fields found');
          }
        });
      });
    };


    /*
    Update the marker and popup after a form (Stand Count or ERL) is completed
     */

    Keyfields_SubHandler.prototype.updatePopupAndMarker = function(currentTarget, field_id, buttonClass) {
      var btn, fid, marker, obj, ref, results, self, status, statusIcon, tbody, td, view;
      self = this;
      btn = $("#map_canvas").find(currentTarget);
      td = btn.closest('td');
      tbody = btn.closest('tbody');
      if (btn.hasClass('first')) {
        $(td).next().find(buttonClass).first().removeAttr('disabled');
      } else {
        btn.closest('tr').next().find(buttonClass).first().removeAttr('disabled');
      }
      $(td).html('Complete');
      view = $(td).closest('.leaflet-popup-content').html();
      ref = self.keyFieldMarkers;
      results = [];
      for (fid in ref) {
        obj = ref[fid];
        if ((parseInt(field_id)) === (parseInt(fid))) {
          if (tbody.find('button').length > 0) {
            status = 'Incomplete';
          } else {
            status = 'Complete';
          }
          statusIcon = self.icons[status];
          marker = L.marker(obj.marker._latlng, {
            icon: statusIcon
          });
          marker.bindPopup(view, {
            maxWidth: 400
          });
          obj.field.bindPopup(view, {
            maxWidth: 400
          });
          self.markerLayer.removeLayer(obj.marker);
          self.markerLayer.addLayer(marker);
          obj.marker = marker;
          obj.marker.openPopup();
          break;
        } else {
          results.push(void 0);
        }
      }
      return results;
    };


    /*
    Fetch fields and add them to the map
     */

    Keyfields_SubHandler.prototype.fetchField = function() {
      var ids, postParams, self;
      self = this;
      ids = this.fieldlist.slice(0, +(this.group_len - 1) + 1 || 9e9);
      this.fieldlist = this.fieldlist.slice(this.group_len);
      if (ids.length === 0) {
        this.loader.destroy();
        return null;
      }
      postParams = {
        years: ko.toJSON(this.year),
        ids: ko.toJSON(ids)
      };
      return this._post = $.post('backend/portal/keyfields/field-info', postParams, function(response) {
        var markers;
        if (self._destroyed) {
          return;
        }
        markers = [];
        self.addFields(response.data);
        App.map.fitBounds(App.layer_store.getBounds());
        self.updateBoundaries();
        return self._timer = setTimeout(function() {
          return self.fetchField();
        }, 0);
      });
    };


    /*
    Add given field data to map
     */

    Keyfields_SubHandler.prototype.addFields = function(fieldData) {
      var data, fld, i, len, mk, results, self, statusIcon;
      self = this;
      results = [];
      for (i = 0, len = fieldData.length; i < len; i++) {
        data = fieldData[i];
        if ((data.field.mid_lat != null) && (data.field.mid_lng != null)) {
          fld = L.geoJson($.parseJSON(data.field.json), {
            style: function() {
              return {
                color: "#00FF00",
                opacity: 1,
                weight: 2,
                fillColor: "#00FF00",
                fillOpacity: 0.1
              };
            }
          });
          statusIcon = self.icons[data.field.status];
          mk = L.marker([data.field.mid_lat, data.field.mid_lng], {
            icon: statusIcon
          });
          if (data.popup != null) {
            mk.bindPopup(data.popup, {
              maxWidth: 400
            });
            fld.bindPopup(data.popup, {
              maxWidth: 400
            });
          }
          mk.on('click', function(e) {
            if (App.map.getZoom() <= self.maxZoom) {
              return App.map.setView(e.latlng, 16);
            } else {

            }
          });
          if (data.field.status !== "Not Key") {
            self.keyFieldMarkers[data.field.id] = {
              'marker': mk,
              'field': fld
            };
          }
          self.boundaryLayer.addLayer(fld);
          results.push(self.markerLayer.addLayer(mk));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    Keyfields_SubHandler.prototype.createViewDialog = function(field_id, operators_id, btn, btnClass, layerName, saveUrl, row) {
      var handler, opts, self;
      if (row == null) {
        row = null;
      }
      self = this;
      handler = this.createSubHandler(layerName);
      if (handler) {
        opts = {
          year: this.year,
          fields_id: field_id,
          users_id: operators_id
        };
        handler.loadLayoutPostOptions = opts;
        handler.sidebar_row = row;
        handler.startEditing = true;
        handler.refreshNavHandler = false;
        handler.btnTarget = btn;
        handler.btnClass = btnClass;
        handler.saveUrl = saveUrl;
        handler.afterHidden = function() {
          return handler.destroy();
        };
        handler.successAction = function() {
          var fid, marker, obj, ref, results, status, statusIcon, tbody, td, view;
          btn = $("#map_canvas").find(handler.btnTarget);
          td = btn.closest('td');
          tbody = btn.closest('tbody');
          if (btn.hasClass('first')) {
            $(td).next().find(handler.btnClass).first().removeAttr('disabled');
          } else {
            btn.closest('tr').next().find(handler.btnClass).first().removeAttr('disabled');
          }
          $(td).html('Complete');
          view = $(td).closest('.leaflet-popup-content').html();
          ref = self.keyFieldMarkers;
          results = [];
          for (fid in ref) {
            obj = ref[fid];
            if ((parseInt(field_id)) === (parseInt(fid))) {
              if (tbody.find('button').length > 0) {
                status = 'Incomplete';
              } else {
                status = 'Complete';
              }
              statusIcon = self.icons[status];
              marker = L.marker(obj.marker._latlng, {
                icon: statusIcon
              });
              marker.bindPopup(view, {
                maxWidth: 400
              });
              obj.field.bindPopup(view, {
                maxWidth: 400
              });
              self.markerLayer.removeLayer(obj.marker);
              self.markerLayer.addLayer(marker);
              obj.marker = marker;
              obj.marker.openPopup();
              break;
            } else {
              results.push(void 0);
            }
          }
          return results;
        };
        return handler.init();
      }
    };

    Keyfields_SubHandler.prototype.createClusterIcon = function(cluster) {
      var c, childCount;
      childCount = cluster.getChildCount();
      c = ' marker-cluster-';
      if (childCount < 10) {
        c += 'small';
      } else if (childCount < 100) {
        c += 'medium';
      } else {
        c += 'large';
      }
      return new L.DivIcon({
        html: '<div class="hex-outer"> <div class="hex-left"></div> <div class="hex-middle"></div> <div class="hex-right"></div> </div> <div class="hex-inner"> <div class="hex-left"></div> <div class="hex-middle"></div> <div class="hex-right"></div> </div> <div class="count-text">' + childCount + '</div>',
        className: 'marker-cluster' + c + ' key-fields-marker-cluster-color',
        iconSize: new L.Point(44, 44)
      });
    };

    Keyfields_SubHandler.prototype.updateBoundaries = function() {
      if (App.map.getZoom() > this.maxZoom) {
        return App.map.addLayer(this.boundaryLayer);
      } else {
        return App.map.removeLayer(this.boundaryLayer);
      }
    };

    Keyfields_SubHandler.prototype.destroy = function() {
      this._destroyed = true;
      if (this._post != null) {
        this._post.abort();
      }
      this.parent.topBuffer = function() {
        return 0;
      };
      App.map.options.maxZoom = this.oldMaxZoom;
      App.map.off('zoomend', this.updateBoundaries);
      App.layer_store.empty();
      return Keyfields_SubHandler.__super__.destroy.call(this);
    };

    return Keyfields_SubHandler;

  })(BaseHandler);

}).call(this);
